import { ANYTIME_PREFERENCE_VALUE } from 'constants/advancedSearch';
import { THEME } from 'GlobalStyles';
import strings from 'strings';

const { priorities: prioritiesValues } = strings.resumeSearch.filters;

export const priorities = [
  {
    id: 'must_have',
    label: prioritiesValues.mustHave,
    shortLabel: 'Must',
    color: THEME.palette.success.main
  },
  {
    id: 'can_have',
    label: prioritiesValues.canHave,
    shortLabel: 'Can',
    color: THEME.palette.primary.main
  },
  {
    id: 'doesnt_have',
    label: prioritiesValues.doesntHave,
    shortLabel: 'Not',
    color: THEME.palette.error.main
  }
];

export const DEFAULT_PROPS = {
  defaultPriority: 'must_have',
  defaultPreference: ANYTIME_PREFERENCE_VALUE
};

export const PRIORITY_CLASS_NAMES = {
  must_have: 'must-have',
  can_have: 'can-have',
  doesnt_have: 'doesnt-have'
};

export const POPOVER_CONFIG = {
  anchorOrigin: {
    horizontal: 'center',
    vertical: 'bottom'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center'
  }
};
